import { useCallback, useEffect, useState } from "react";
import Cookies from "js-cookie";

type PersistDismissalFunctionalityProps = {
  cookiesKey: string;
  timesToDisappear?: number;
};

export default function PersistDismissalFunctionality({
  cookiesKey,
  timesToDisappear = 1,
}: PersistDismissalFunctionalityProps) {
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    const dismissCount = parseInt(Cookies.get(cookiesKey) || "0");
    if (dismissCount < timesToDisappear || timesToDisappear === 0) {
      setShowComponent(true);
    }
  }, [cookiesKey, timesToDisappear]);

  const dismissComponent = useCallback(() => {
    if (timesToDisappear === 0) return;

    const dismissCount = parseInt(Cookies.get(cookiesKey) || "0");
    Cookies.set(cookiesKey, (dismissCount + 1).toString());
    setShowComponent(false);
  }, [cookiesKey]);

  return {
    showComponent,
    dismissComponent,
  };
}
